import { scrollTo } from 'app/shared/utils/scrollTo';
import { scrollToForIOS12IframeHack } from 'app/shared/utils/scrollToForIOS12IframeHack';
import { isInIframe, userAgent } from 'config/system';

export function scrollToSubject(subjectId: number) {
  const subject = document.querySelector(`[data-subject-id="${subjectId}"]`);

  if (subject) {
    if (userAgent.isIOSVersionBelow12 && isInIframe) {
      scrollToForIOS12IframeHack(subject as HTMLElement);
    } else {
      scrollTo(subject as HTMLElement, document.body.scrollHeight / 0.75);
    }
  }
}
